import { stringifyQuery, getQuery } from '@bilibili/magic-bag/url';
import isIframe from '@bilibili/magic-bag/isIframe';
import { getSourceConfig } from './small-shop-decoration/utils';

const outsideList = ['ticket', 'up'];
const { hash } = window.location;
const urlQuery = getQuery(hash);
const isOutside = outsideList.includes(urlQuery.clientFrom);

export default (router) => {
    if (isOutside) {
        return router;
    }
    if (!isIframe) {
        router.openBlank = (params) => {
            let url = params;
            if (typeof params === 'string') {
                if (/^http(s{0,1}):\/\//.test(url)) {
                    window.open(url);
                    return;
                }
                if (/^\/\//.test(url)) {
                    window.open(`${location.protocol}${url}`);
                    return;
                }
                url = `#${params}`;
            } else if (typeof params !== 'string' && params.path) {
                const query = params.query ? stringifyQuery(params.query) : '';
                url = `#${url.path}${query}`;
            }
            const { origin, pathname } = location;
            window.open(`${origin}${pathname}${url}`);
        };
        return router;
    }
    const targetOrigin = getSourceConfig().targetOrigin || window.top.location.href;
    router.go = (param) => {
        window.top.postMessage(
            {
                payload: {
                    type: 'go',
                    param
                },
                source: 'expandRouter'
            },
            window.top.location.href
        );
    };
    router.push = (param) => {
        if (param.name) {
            const { path, query, params } = router.resolve(param);
            param.path = path;
            param.query = query;
            param.params = params;
            delete param.name;
        }
        window.top.postMessage(
            {
                payload: {
                    type: 'push',
                    param
                },
                source: 'expandRouter'
            },
            targetOrigin
        );
    };
    router.replace = (param) => {
        if (param.name) {
            const { path, query, params } = router.resolve(param);
            param.path = path;
            param.query = query;
            param.params = params;
            delete param.name;
        }
        window.top.postMessage(
            {
                payload: {
                    type: 'replace',
                    param
                },
                source: 'expandRouter'
            },
            targetOrigin
        );
    };
    /**
     * param
     * @String 新标签页打开当前路由
     * @Object
     *  - @url 打开路由
     *  - @base 指定某一html单页面模式
     *  - @native window的open拓展, 直接打开url, 不做拼接
     */
    router.openBlank = (param) => {
        window.top.postMessage(
            {
                payload: {
                    type: 'openBlank',
                    param
                },
                source: 'expandRouter'
            },
            window.top.location.href
        );
    };
    /**
     * param
     * @String location.href 拓展, 直接打开url, 不做拼接
     */
    router.pushHref = (param) => {
        window.top.postMessage(
            {
                payload: {
                    type: 'pushHref',
                    param
                },
                source: 'expandRouter'
            },
            window.top.location.href
        );
    };
    router.preview = (param) => {
        window.top.postMessage(
            {
                payload: {
                    type: 'preview',
                    param
                },
                source: 'viewControl'
            },
            window.top.location.href
        );
    };
    return router;
};
